import { Grid, IconButton, Table, TableBody, TableCell, Typography } from '@mui/material'
import React from 'react'
import * as S from './styles'
import { Container } from '@mui/material'
import { CopyAll } from '@mui/icons-material'
import { alertNotification } from '../AlertNotification'

interface Row {
  key: string | React.ReactNode
  value: string | React.ReactNode
}

interface SummaryTableProps {
  data: Row[]
  padding?: number | string
  title: string
}

const SummaryTableCard: React.FC<SummaryTableProps> = ({ data, padding, title }: SummaryTableProps) => {
  const copyToClipboard = (value: string) => {
    navigator.clipboard.writeText(value)
    alertNotification(`Successfully copied '${value}' to clipboard!`, 'success')
  }
  return (
    <Container
      sx={{ borderRadius: 2, borderColor: 'grey.300', borderWidth: 1, borderStyle: 'solid', overflow: 'hidden' }}
    >
      <Typography
        variant="h6"
        fontWeight={600}
        sx={{ marginBottom: 2, backgroundColor: 'grey.100', marginInline: -3, paddingInline: 3, paddingBlock: 1 }}
      >
        {title}
      </Typography>
      <Table size="small">
        <TableBody>
          {data.map((row, i) => {
            return (
              <S.StyledTableRow
                key={i}
                padding={padding}
                sx={{ backgroundColor: i % 2 === 0 ? 'transparent' : 'grey.50' }}
              >
                <TableCell sx={{ maxWidth: 100, alignContent: 'center' }}>
                  <Typography variant="body2">{row.key}</Typography>
                </TableCell>
                <TableCell align="right" sx={{ alignContent: 'center' }}>
                  <Grid container alignItems="center" justifyContent="flex-end" wrap="nowrap">
                    <Grid item>
                      <Typography variant="body1" fontWeight={800}>
                        {row.value}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <IconButton
                        size="small"
                        onClick={() => copyToClipboard(row.value as string)}
                        aria-label="copy value"
                      >
                        <CopyAll fontSize="small" />
                      </IconButton>
                    </Grid>
                  </Grid>
                </TableCell>
              </S.StyledTableRow>
            )
          })}
        </TableBody>
      </Table>
    </Container>
  )
}

export default SummaryTableCard
